<template>
  <v-text-field ref="textfield" :name="name" :maxlength="maxlength" :required="required" :counter="counter" :autofocus="autofocus" :disabled="disabled" :readonly="readonly" :outline="outline" :solo="solo" :error-messages="errorMessages" :value="value" :prefix="prefix" :rules="rules" :label="label" :type="type" :loading="loading"
  :append-icon="appendIcon" :clearable="clearable" :clear-icon="clearIcon"
  :data-testid="dataTestid" :placeholder="placeholder" v-bind="$attrs" v-on="$listeners">
    <template slot="append">
      <slot name="append"/>
    </template>
    <template slot="append-outer">
      <slot name="append-outer"/>
    </template>
  </v-text-field>
</template>

<script>
export default {
  props: {
    maxlength: {
      type: String,
      default: undefined
    },
    required: {
      type: Boolean,
      default: false
    },
    counter: {
      type: String,
      default: undefined
    },
    label: {
      type: String,
      default: undefined
    },
    placeholder: {
      type: String,
      default: undefined
    },
    value: {
      default: undefined
    },
    autofocus: {
      default: undefined
    },
    type: {
      type: String,
      default: 'text'
    },
    rules: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    outline: {
      type: Boolean,
      default: false
    },
    solo: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: [String, Array],
      default: () => null
    },
    appendIcon: {
      default: null
    },
    clearIcon: {
      default: '$clear'
    },
    loading: {
      type: Boolean,
      default: false
    },
    prefix: {
      type: String,
      default: undefined
    },
    dataTestid: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    }
  },
  methods: {
    focus: function () {
      this.$refs.textfield.focus();
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/ui/FormTextField.vue